import { DomainUnfilledRecovery } from '../../types/domainUnfilledRecovery'

export const isUnfilledRecoveryConfigured = (
  baseAdUnitPath: DomainUnfilledRecovery['baseAdUnitPath'],
): boolean => baseAdUnitPath !== undefined && baseAdUnitPath.length > 0
